import { legacy_createStore as createStore,applyMiddleware,compose} from 'redux';
import rootReducer from "./reducers";
import {thunk} from 'redux-thunk';

const composeEnhancers = compose
const enchancer = composeEnhancers(applyMiddleware(...[thunk]));
const store = createStore(rootReducer,enchancer);

export default store;
